import { render, staticRenderFns } from "./AddEditProductMappingTemplate.vue?vue&type=template&id=150016f4&scoped=true&"
import script from "./AddEditProductMappingTemplate.vue?vue&type=script&lang=js&"
export * from "./AddEditProductMappingTemplate.vue?vue&type=script&lang=js&"
import style0 from "./AddEditProductMappingTemplate.vue?vue&type=style&index=0&id=150016f4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "150016f4",
  null
  
)

export default component.exports